import { Autocomplete } from 'src/components/Autocomplete';
import { Chip } from 'src/components/Chip';
import { TextField } from 'src/components/TextField';

interface MiaFilterProps {
  label: string;
  value: string[] | undefined;
  setValue: (newVal: string[]) => void;
  valueOnly?: boolean;
}

const miaOptions = [
  { id: "Hasn't Logged Workout", name: "Hasn't Logged Workout" },
  { id: "Hasn't Checked In", name: "Hasn't Checked In" },
  { id: "Hasn't Booked Session", name: "Hasn't Booked Session" },
  { id: "Hasn't Purchased Anything", name: "Hasn't Purchased Anything" },
  { id: "Hasn't Completed Assessment", name: "Hasn't Completed Assessment" },
];

export const MiaFilter: React.FC<MiaFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedValues = value ? String(value).split(',') : [];

  if (valueOnly) {
    return selectedValues.length > 0 ? (
      <>
        {selectedValues
          .map((v) => miaOptions.find((option) => option.id === v)?.name || '')
          .join(', ')}
      </>
    ) : null;
  }

  const selectedOptions = selectedValues.map(
    (v) => miaOptions.find((option) => option.id === v) || { id: v, name: v }
  );

  return (
    <Autocomplete
      multiple
      options={miaOptions}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? miaOptions.find((o) => o.id === option)?.name || option
          : option.name
      }
      value={selectedOptions}
      onChange={(_, newValue) => {
        setValue(
          newValue.map((v) => (typeof v === 'string' ? v : v.id)).join(',')
        );
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select MIA Status" />
      )}
      renderTags={(value: readonly any[], getTagProps) =>
        value.map((option: any, index: number) => {
          const { key, ...tagProps } = getTagProps({ index });
          return (
            <Chip
              label={typeof option === 'string' ? option : option.name}
              key={key}
              {...tagProps}
            />
          );
        })
      }
    />
  );
};
